import { Farm } from "@abaco/farm-registry/src/modules/farm-registry/models/Farm";
import { Plot } from "@abaco/portal-global-state/src/modules/global-state/models/Plot";
import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Agreement } from "./models/Agreements";
import { SCRegion, SCProvince } from "./models/FieldVisitPerAgronomist";
import { FilterPlot } from "@abaco/portal-global-state/src/modules/global-state/models/Plot";
import { Crop } from "./models/SCSModels";

export default class FerreroFixedDashboardVuexModule extends AbacoVuexModule {
    @State({ default: null }) plotIdToZoom!: number | null;
    @State({ default: null }) blockIdToZoom!: number | null;
    @State({ default: false }) hasSupplyChainView!: boolean;
    @State({ default: false }) loadingPlotCompetences!: boolean;
    @State({ default: false }) farmSelectedForMapPlotSelection!: boolean;
    @State({ default: null }) plotFarmInternal!: Farm | null;
    @State({ default: null }) homeMapCenter!: { lat: number; lng: number } | null;
    @State({ default: null }) homeMapZoom!: number | null;
    @State({ default: null }) dashboardSelectedFarm!: Farm | null;
    @State({ default: 0 }) showFarmEdit!: number;
    @State({ default: [] }) farmsPlots!: { subjectId: number; plots: Plot[] }[];
    @State({ default: null }) curAgreement!: Agreement | null;
    @State({ default: null }) curActivity!: any | null;
    @State({ default: false }) agreementViewAuth!: boolean;
    @State({ default: false }) agreementInsertAuth!: boolean;
    @State({ default: false }) agreementEditAuth!: boolean;
    @State({ default: null }) curRegion!: SCRegion | null;
    @State({ default: null }) curProvince!: SCProvince | null;
    @State({ default: false }) hasPlotInsertAuthByUser!: boolean;

    @State() curCulture!: Crop | null;
    @State({ default: { rotation: 1 } }) crossFilters!: FilterPlot;
    @State() proseccoFromTableToMap!: number[];
}
